import { useIntl } from '@/intl'
import { useState } from 'react'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    trialTitle: translate({ id: 'settings.messagingPlan.view.smsPlan.trialTitle' }),
    trialSubtitle: translate({ id: 'settings.messagingPlan.view.smsPlan.trialSubtitle' }),

    allowOverageTitle: translate({ id: 'settings.messagingPlan.view.smsPlan.allowOverageTitle' }),
    allowOverageSubtitle: translate({
      id: 'settings.messagingPlan.view.smsPlan.allowOverageSubtitle',
    }),

    dontAllowOverageTitle: translate({
      id: 'settings.messagingPlan.view.smsPlan.dontAllowOverageTitle',
    }),
    dontAllowOverageSubtitle: translate({
      id: 'settings.messagingPlan.view.smsPlan.dontAllowOverageSubtitle',
    }),
    expiryDate: translate({ id: 'settings.messagingPlan.view.smsPlanExpiryDatesLabel' }),
    expiring: (expireDate: string, daysToExpire: number) =>
      translate({
        id: 'settings.messagingPlan.view.smsPlanExpiresOn',
        values: { expireDate, daysToExpire },
      }),
    creditConsumption: (count: number) =>
      translate({
        id: 'settings.messagingPlan.view.creditConsumption',
        values: { count },
      }),
    callsLabel: translate({
      id: 'settings.messagingPlan.view.callsLabel',
    }),
    smsLabel: translate({
      id: 'settings.messagingPlan.view.smsLabel',
    }),
    planUsage: (name: string) =>
      translate({ id: 'settings.messagingPlan.view.smsPlanUsage', values: { name } }),
    durationMonths: (duration: number) =>
      translate({ id: 'settings.messagingPlan.view.smsPlanDurationMonths', values: { duration } }),
    currentPlanLabel: translate({
      id: 'settings.messagingPlan.view.smsPlan.currentPlanLabel',
    }),
    currentPlanDescription: translate({
      id: 'settings.messagingPlan.view.smsPlan.currentPlanDescription',
    }),
    changePlan: translate({ id: 'settings.messagingPlan.view.changePlan' }),
    creditBalanceLabel: translate({
      id: 'settings.messagingPlan.view.smsPlan.creditBalanceLabel',
    }),
    creditBalanceDescription: translate({
      id: 'settings.messagingPlan.view.smsPlan.creditBalanceDescription',
    }),
    usageOverviewLabel: translate({
      id: 'settings.messagingPlan.view.smsPlan.usageOverviewLabel',
    }),

    phoneNumbersCopyButtonLabel: translate({
      id: 'settings.messagingPlan.phoneNumbersModal.copy.label',
    }),
    phoneNumbersTitle: translate({
      id: 'settings.messagingPlan.phoneNumbersModal.header.title',
    }),
    phoneNumbersSubtitle: translate({
      id: 'settings.messagingPlan.phoneNumbersModal.header.subtitle',
    }),

    copyPhoneNumbersSuccess: translate({
      id: 'settings.messagingPlan.phoneNumbersModal.controls.copyNumbers.success',
    }),

    copyPhoneNumbersError: translate({
      id: 'settings.messagingPlan.phoneNumbersModal.controls.copyNumbers.error',
    }),
    changePlanDisabled: translate({ id: 'settings.messagingPlan.view.changePlan.tooltip.title' }),
  }))

  return api
}
